// "Enable PoC (Primary Group)" for one radio: the radio's all-PoC switch (radios.poc_enabled, PUT
// /api/admin/radios/{id}/poc-enabled), shown first in Radio-Specific Settings > Features as a plain
// checkbox row like the other features. Off means no PoC at all (Primary Group, Secondary Group,
// direct PoC calls); the radio stays connected and DMR is unaffected. Applies to every model, default
// on. The change is sent when the editor is saved.

export default function PocSwitch({
  enabled,
  saved,
  onChange,
}: {
  enabled: boolean;
  /** The value currently stored on the server, to flag an unsaved change. */
  saved: boolean;
  onChange: (enabled: boolean) => void;
}) {
  return (
    <>
      <label className="flex items-center gap-2 text-sm text-gray-300" data-poc-switch>
        <input type="checkbox" checked={enabled} onChange={(e) => onChange(e.target.checked)} />
        Enable PoC (Primary Group)
        {enabled !== saved && <span className="text-xs text-gray-400" data-poc-unsaved>(unsaved - applied on Save)</span>}
      </label>
      <p className="text-xs text-gray-500 -mt-2">
        Off turns off ALL PoC on this radio: Primary Group, Secondary Group and direct PoC calls. The radio stays online
        for management, and DMR keeps working. Group assignments are kept.
      </p>
    </>
  );
}
